import { QueryKey } from '@tanstack/react-query'
import { QueryParams } from '@opallabs/api'
import { BoardKey } from '@opallabs/api/v3'

export const queryKeys = {
  boards: (workspaceUuid: string, query?: QueryParams): QueryKey =>
    query ? ['boards', workspaceUuid, { query }] : ['boards', workspaceUuid],
  /** Prefix of a board's side queries. The board document is keyed by `boardIdentifiers`. */
  boardScope: (workspaceUuid: string, boardId: string): QueryKey => [
    ...queryKeys.boards(workspaceUuid),
    boardId,
  ],
  boardIdentifiers: (workspaceUuid: string, boardId: string): BoardKey => ({
    workspaceUuid,
    resourceId: boardId,
    queryParams: null,
  }),
  boardDuplicationStatus: (
    workspaceUuid: string,
    boardId: string,
    boardDuplicationId: string
  ): QueryKey => [
    ...queryKeys.boardScope(workspaceUuid, boardId),
    boardDuplicationId,
  ],
  boardCollaborators: (workspaceUuid: string, boardId: string): QueryKey => [
    ...queryKeys.boardScope(workspaceUuid, boardId),
    'collaborators',
  ],
  boardCollections: (workspaceUuid: string, boardId: string): QueryKey => [
    ...queryKeys.boardScope(workspaceUuid, boardId),
    'collections',
  ],
  boardColumns: (workspaceUuid: string): QueryKey => [
    ...queryKeys.boards(workspaceUuid),
    'boardColumns',
  ],
  boardColumnsByBoard: (workspaceUuid: string, boardId: string): QueryKey => [
    ...queryKeys.boards(workspaceUuid),
    'boardColumns',
    boardId,
  ],
  boardStandardColumns: (): QueryKey => ['boardStandardColumns'],
  boardOwner: (boardOwnerId?: string) => ['users', boardOwnerId],
  boardUserSetting: (workspaceUuid: string, boardId: string): QueryKey => [
    ...queryKeys.boardScope(workspaceUuid, boardId),
    'boardUserSetting',
  ],
  workspaceBoardCollections: (workspaceUuid: string): QueryKey => [
    ...queryKeys.boards(workspaceUuid),
    'collections',
  ],
  momentById: (momentId?: string, query?: QueryParams): QueryKey =>
    query ? ['moments', momentId, { query }] : ['moments', momentId],
}
